
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { resultScreen } from 'modules/foc/interfaces/result-screen.model';
import { ProductViewHelperService } from 'modules/foc/services/product-view-helper.service';
import { ThemeService } from "libs-frontend-micro-base";

@Component({
    selector: 'result-screen',
    templateUrl: './result-screen.template.html',
	standalone: false,
    styleUrls: ['./result-screen.style.scss']
})
export class ResultScreen implements OnInit {
    
    selectedItemSubscription: Subscription;
    paramsSubscription: Subscription;
    @Input() selectedItem: any = {};
    @Input() productCode: string;
    @Input() userRole: string;
    /* Const object to determine the text/styles/assets to be shown on the result screen */
    resultScreen: any = resultScreen;
    /* Object containing result data to be shown on the result screen */
    resultData: any = {};
    /* Product segment style */
    style: string;
    segment: string = '';
    /* Threshold acheived (above/below) by the user */
    threshold: string;
    /* Object containing control type and action to perform on click of review button (for case when C1 result screen shown) */
    reviewAction: any = {
        controlType: '',
        action: '',
    };

    USER_ROLE = {
        STUDENT : "student",
        TEACHER : "teacher",
    }

    /* Boolean to show/hide result screen */
    @Input() showResultScreen: boolean;
    /* launch next activity */
    @Output() exitActivity = new EventEmitter<string>();
    /* launch activity again */
    @Output() relaunchActivity = new EventEmitter<string>();
    @Output() actionControl = new EventEmitter<any>();
    /* To trigger show results event */
    @Input() showResultScreenEvent: Subject<any>;
    @Input() productTocData: any;
    
    themeService;
    showGreenTickERS = false;

    constructor(
        private productViewHelperService: ProductViewHelperService,
    ) {
        this.themeService = new ThemeService();
    }

    ngOnInit() {
        // Get segment - to display corresponding result screen accordingly
        const classProduct = this.productTocData.bundleDetails.products.find((product) => product['dls-product'].code === this.productCode);
        // console.log('product', this.productTocData)
        this.segment = classProduct.segment ? classProduct.segment.segment : 'primary';
        this.style = (this.segment === 'primary') ? 'primary-type-1' : 'secondary-type-1';
        
        // activating segment based theme on the ERS
        this.themeService.activateThemeOnComponent(this.segment, "c1-eReader-LO-ERS");
        
        this.showResultScreenEvent.subscribe((containerEventData) => {
            let LOinitParams = this.productViewHelperService.getLOInitParams();
            /* Temp hardcoding - content will provide the action in future */
            this.reviewAction.controlType = LOinitParams.container.type === 'generic-content' ? 'generic_controls' : 'avallain_controls';
            this.reviewAction.action = this.reviewAction.controlType === 'generic_controls' ? 'reviewAnswers' : 'goToExerciseScreen';
            this.resultData = containerEventData;
            let toc = this.productTocData.toc.tocObject;
            let passScore = toc[this.selectedItem.unitId].items[this.selectedItem.lessonId].items[this.selectedItem.activityId]['pass-score'];
            if((this.userRole == this.USER_ROLE.TEACHER) && (containerEventData.score == undefined)){
                this.showGreenTickERS = true;
            }else{
                this.showGreenTickERS = false;
            }

            if(containerEventData.score?.scaled) {
                this.threshold = containerEventData.score.scaled >= passScore ? 'top_threshold' : 'bottom_threshold';
            } else {
                this.threshold =  'bottom_threshold';
            }
        });
    }
    ngOnDestroy() {
        this.showResultScreenEvent.unsubscribe();
    }

    closeActivity() {
        this.exitActivity.emit();
    }

    launchActivityAgain() {
        this.relaunchActivity.emit();
    }

    reviewAnswers(containerType, type) {
        this.actionControl.emit({ containerType: containerType, type: type });
    }

}
